var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNodeFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_534",
    "data-name": "Rectangle 534",
    width: 36,
    height: 36,
    transform: "translate(0 0.168)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_234",
    "data-name": "Group 234",
    transform: "translate(0 -0.168)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_114",
    "data-name": "Path 114",
    d: "M29.693,13.654H20.808V10.025H19.139v3.629H9.252a2.5,2.5,0,0,0-2.5,2.5v7.718a2.505,2.505,0,0,0,2.5,2.5h9.887v3.629h1.669V26.378h8.886a2.5,2.5,0,0,0,2.5-2.5V16.157a2.5,2.5,0,0,0-2.5-2.5m.834,10.221a.836.836,0,0,1-.834.834H20.808V15.323h8.886a.836.836,0,0,1,.834.834Z",
    transform: "translate(-0.987 -2.016)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNodeFill);
export default __webpack_public_path__ + "static/media/nodeFill.9d1cf2bf7c3ea4811267e906e959c4c9.svg";
export { ForwardRef as ReactComponent };